import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  error: "",
  loading: false,
  loadingmsg: "",
  isLoading: false,
  isReconnecting: false,
  activeRequests: [],
  isStrategist: false,
  isInvestor: false,
  websocketDisconnected: false,
  websocketManualReconnect: false,
  fetchedHistoricalDates: [],
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    updateLoading: (state, { payload }) => {
      state.loading = Boolean(payload);
    },
    updateLoadingMsg: (state, { payload }) => {
      state.loadingmsg = payload;
    },
    updateLoadingAxios: (state, { payload }) => {
      state.isLoading = Boolean(payload);
    },
    updateIsStrategist: (state, { payload }) => {
      state.isStrategist = Boolean(payload);
    },
    updateIsInvestor: (state, { payload }) => {
      state.isInvestor = Boolean(payload);
    },
    setReconnecting: (state, action) => {
      state.isReconnecting = action.payload;
    },
  
    addActiveRequests: (state, action) => {
      state.activeRequests.push(action.payload);
    },
    removeActiveRequests: (state, action) => {
      state.activeRequests = state.activeRequests.filter(
        (request) => request !== action.payload
      );
    },
    clearActiveRequests: (state) => {
      state.activeRequests = [];
    },
    markDateAsFetched: (state, action) => {
      const dateToAdd = action.payload;
      if (!state.fetchedHistoricalDates.includes(dateToAdd)) {
        state.fetchedHistoricalDates.push(dateToAdd);
      }
    },
    setWebsocketDisconnected: (state, action) => {
      state.websocketDisconnected = action.payload;
    },
    setWebsocketManualReconnect: (state, action) => {
      state.websocketManualReconnect = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = "";
    },
  
  },
});

export const {
  updateLoading,
  updateLoadingMsg,
  updateLoadingAxios,
  updateIsStrategist,
  updateIsInvestor,
  setReconnecting,
  addActiveRequests,
  removeActiveRequests,
  clearActiveRequests,
  markDateAsFetched,
  setWebsocketDisconnected,
  setWebsocketManualReconnect,
  setError,
  clearError,
} = uiSlice.actions;

// Selectors - Direct access to UI state
export const selectLoading = (state) => state.ui?.loading || false;
export const selectLoadingMsg = (state) => state.ui?.loadingmsg || "";
export const selectIsLoading = (state) => state.ui?.isLoading || false;
export const selectIsStrategist = (state) => state.ui?.isStrategist || false;
export const selectIsInvestor = (state) => state.ui?.isInvestor || false;
export const selectIsReconnecting = (state) => state.ui?.isReconnecting || false;
export const selectActiveRequests = (state) => state.ui?.activeRequests || [];
export const selectWebsocketDisconnected = (state) => state.ui?.websocketDisconnected || false;
export const selectWebsocketManualReconnect = (state) => state.ui?.websocketManualReconnect || false;
export const selectFetchedHistoricalDates = (state) => state.ui?.fetchedHistoricalDates || [];
export const selectError = (state) => state.ui?.error || "";

export default uiSlice.reducer;